import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeComponent } from "./home.component";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule, SeoServiceService } from "@xref/ngx";
import { FeatureListModule } from "src/app/components/feature-list/feature-list.module";
import { FooterMarketingModule } from "src/app/components/footer-marketing/footer-marketing.module";

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    TranslateModule,
    FeatureListModule,
    FooterMarketingModule,
  ],
  exports: [HomeComponent],
  providers: [SeoServiceService],
})
export class HomeModule {}
